<template>
<!-- :style="{'background':this.projectColor+'!important'}" -->
  <div class="navbar">
    <div class="goback">
        <img :src="schoollogo" alt="" class="header_Logo">
        <span title="返回首页" @click="routerTo" style="cursor: pointer;height:60px;line-height:60px;font-size:22px;color:#fff;float:left;">
          &nbsp;{{schoolname}}&nbsp;<span style="font-size:16px;">{{schoolHname}}</span>
        </span>
        <!-- <img src="@/assets/images/portal/logo2.png" alt="" title="返回首页" @click="routerTo" style="cursor: pointer;"> -->
    </div>
    <div class="right-nav">
      <div class="service">{{tenantService}}</div>
      <!-- <template v-if="device!=='mobile'">
        <el-tooltip content="全屏" effect="dark" placement="bottom">
          <screenfull class="screenfull right-menu-item"/>
        </el-tooltip>
      </template> -->
      <div class="right-menu">
        <!-- <template v-if="device!=='mobile'">
          <el-tooltip content="全屏" effect="dark" placement="bottom">
            <screenfull class="screenfull right-menu-item"/>
          </el-tooltip>
        </template> -->
        <el-dropdown class="avatar-container right-menu-item" trigger="hover">
          <div class="avatar-wrapper">
            <img :src="avatar" class="user-avatar">
          </div>
          <el-dropdown-menu slot="dropdown">
            <router-link to="/tenant">
              <el-dropdown-item>
                回到首页
              </el-dropdown-item>
            </router-link>
            <router-link to="/personalT" v-if="infoShow">
              <el-dropdown-item>
                <span>个人中心</span>
              </el-dropdown-item>
            </router-link>
            <el-dropdown-item divided>
              <span style="display:block;" @click="LogOutT">退出登录</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import request from '@/utils/request'

export default {
  components: {
  },
  computed: {
    ...mapGetters([
      // 'sidebar',
      'avatar',
    ])
  },
  // 跳转首页刷新页面
  inject:['reload'],
  data(){
    return {
        infoShow:true,
        tenantService:'',
        tenantName:'',
        schoolname:'',
        schoolHname:'',
        schoollogo:'',
        tenantId:'',
        resource:'',
    }
  },
  created(){
    this.getinfo();
  },
  methods: {
    //获取info
    getinfo(){
      request({
        method:'get',
        url:'auth/info'
      }).then(res=>{
          this.tenantName = res.tenant.tenantName
          this.tenantId = res.tenant.id
          this.projectColor = res.tenant.projectColor
          this.schoolname = res.tenant.tenantName
          this.schoolHname = res.tenant.tenantHName
          this.schoollogo = res.tenant.tenantHLogo
          this.tenantService = res.tenant.tenantService
          this.resource = res.resource
          if(res.tenant.tenantInfo == 0){
            this.infoShow = false
          }
      })
    },
    // 跳转首页刷新页面
    routerTo(){
      this.$router.push({path:'/tenant'});
      this.reload();
    },
    // 退出登陆
    LogOutT() {
     if(this.tenantId == 13){
        this.$store.dispatch('LogOutT').then(() => {
          this.reload() // 为了重新实例化vue-router对象 避免bug
          this.$router.push({path:'/party'});
        })
      }else if(this.tenantId == 25 || this.tenantId == 19){
        this.$store.dispatch('LogOutT').then(() => {
          this.reload() // 为了重新实例化vue-router对象 避免bug
          this.$router.push({path:'/partyM'});
        })
      }else if(this.tenantId == 34){
        this.$store.dispatch('LogOutT').then(() => {
          this.reload() // 为了重新实例化vue-router对象 避免bug
          this.$router.push({path:'/partyHN'});
        })
      }else if(this.resource !== null){
        this.$store.dispatch('LogOutT').then(() => {
          this.reload() // 为了重新实例化vue-router对象 避免bug
          this.$router.push({path:'/partyM'});
        })
      }else{
        this.$store.dispatch('LogOutT').then(() => {
          this.reload() // 为了重新实例化vue-router对象 避免bug
          this.$router.push({path:'/infoTenant?tenantNum='+this.tenantId});
        })
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (min-width:769px) and (max-width: 1024px){
    .ques{
      display: none;
    }
  }
.right-nav{
  float:right;
  height: 100%;
}
.service{
  float: left;
  line-height: 60px;
  color: #fff;
  font-size: 12px;
  padding-right: 20px;
}
.goback{
  height: 60px;
  margin-left: 30px;
  float: left;
  display: flex;
  align-items: center;
}
.header_Logo{
   float: left;
   display: inline-block;
   max-height: 52px;
   vertical-align: middle;
   align-items: center;
}
  .navbar {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 2000;
    height: 60px;
    background: linear-gradient(to right, #1b7ccc 10%, #005faf 100%);
    border-bottom: transparent;
    border-radius: 0px !important;
    .hamburger-container {
      line-height: 58px;
      height: 60px;
      float: left;
      padding: 0 10px;
    }
   .app-breadcrumb.el-breadcrumb{
     display: none;
   }
    .breadcrumb-container{
      float: left;
    }
    .errLog-container {
      display: inline-block;
      vertical-align: top;
    }
    .right-menu {
      float: right;
      height: 100%;
      &:focus{
        outline: none;
      }
      .right-menu-item {
        display: inline-block;
        margin: 0 8px;
      }
      .screenfull {
        height: 20px;
      }
      .international{
        vertical-align: top;
      }
      .theme-switch {
        vertical-align: 15px;
      }
      .avatar-container {
        height: 60px;
        margin-right: 30px;
        .avatar-wrapper {
          margin-top: 9px;
          position: relative;
          .user-avatar {
            cursor: pointer;
            width: 40px;
            height: 40px;
            border-radius: 10px;
          }
          .el-icon-caret-bottom {
            cursor: pointer;
            position: absolute;
            right: -20px;
            top: 25px;
            font-size: 12px;
          }
        }
      }
    }
  }
  .el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover{
    background-color: #d5eafc;
    color: #005faf;
  }
  // .el-select-dropdown{
  //   margin-top: -8px !important;
  //   left: 170px !important;
  // }
  .el-select-dropdown__item.hover, .el-select-dropdown__item:hover{
    background-color:#d5eafc;
  }
  .el-select-dropdown__item.selected{
    color: #005faf;
  }
</style>


// WEBPACK FOOTER //
// src/views/layout/components/Tenantbar.vue